<template>
    <v-container fluid ma-0 pa-0>
        <v-layout row wrap justify-center>
            <v-flex xs12 sm5 md5>
                <v-img

                        :src="require('@/assets/img/innovation/challenge.jpg')"
                >
                </v-img>
            </v-flex>


            <v-flex xs12 sm7 md7>
                <v-container grid-list-sm text-xs-left pa-5>
                    <v-layout row wrap>
                        <v-flex xs12 py-3>
                            <!--<span class="headline strong">Insert your personal token to participate and upload your document!</span>-->
                            <span class="headline strong">NTT DATA Discovery sends personal tokens to the startups at startup registration time. You should have received this token via mail soon after completing the registration process.</span>
                        </v-flex>
                        <v-flex xs12>
                            <v-text-field
                                    box
                                    v-model="token"
                                    label="Token"
                            ></v-text-field>
                        </v-flex>
                        <v-flex xs12 py-3>
                            <span class="headline strong">Please describe at your best the solution you propose to address the challenge, identifying the components and their role, explaining the use cases and pointing out the business value. Pictures and schemes are welcome. The solution must leverage the value proposition of your startup.</span>
                        </v-flex>
                        <v-flex xs12>
                            <FileInputChallenge
                                    label="Upload a PDF file (max 5 MB)"
                                    accept=".pdf"
                                    required
                                    @update="getFile"
                            />
                        </v-flex>
                        <v-flex xs12 class="text-xs-center" >
                            <vue-recaptcha ref="recaptcha" sitekey="6LfZA3cqAAAAAM24XBOAwmmDmoLgPdpxDM_hZf6l" @verify="register" @expired="onCaptchaExpired">
                                <div style="display: inline-block" id="html-element"></div>
                                <br>
                                <v-btn dark color="primary" @click="submitCaptcha" :dark="validCaptcha && TECAccepted" :disabled="!validCaptcha || !TECAccepted">Participate</v-btn>
                                <v-flex pt-3 v-if="!TECAccepted">
                                    <span style="color:red">* You have to accept Terms & Conditions. Click <a style="text-decoration: underline;" @click="dialogTEC = true">here</a></span>
                                </v-flex>
                                <v-flex pt-3 v-else>
                                    <span style="color:red">* <a style="text-decoration: underline;" @click="dialogTEC = true">Terms & Conditions</a> accepted.</span>
                                </v-flex>
                            </vue-recaptcha>

                        </v-flex>
                        <v-flex xs12 py-5>
                            <span class="title">If you have lost or forgotten your token <a href="mailto:nttdata.discovery@nttdata.com?subject=Token%20request">contact</a> the NTT DATA Discovery administrators.
                            </span>
                        </v-flex>
                        <v-flex xs12 py-3>
                            <span class="title">If you are not registered to NTT DATA Discovery and you haven't the token, register <a style="text-decoration: underline;" @click="navigate('/startup/registration')">here</a>.
                            </span>
                        </v-flex>
                    </v-layout>
                </v-container>
            </v-flex>
        </v-layout>

        <v-dialog v-model="tokenStatus" max-width="450">
            <v-card v-if="tokenError">
                <v-card-title class="headline error white--text">Registration failed</v-card-title>
                <v-card-text>Your token is not valid!</v-card-text>
            </v-card>
            <v-card v-else>
                <v-card-title class="headline success white--text">Registration successfully completed</v-card-title>
                <v-card-text>We will evaluate your proposal as soon as possibile!</v-card-text>
            </v-card>
        </v-dialog>

        <!-- T&C dialog -->
        <v-dialog v-model="dialogTEC" max-width="1000" persistent scrollable>
            <v-card>
                <v-card-title>
                    <span class="headline">Terms & Conditions</span>
                    <v-spacer></v-spacer>
                    <v-card-actions>
                        <v-btn icon @click="dialogTEC=false"><v-icon>mdi-close</v-icon></v-btn>
                    </v-card-actions>
                </v-card-title>
                <v-card-text>
                    <v-flex>
                        <v-stepper class="elevation-0" v-model="stepper" vertical>
                            <v-stepper-step editable edit-icon="$vuetify.icons.complete" :complete="stepper > 1" step="1">
                                Read Terms & Conditions
                                <small>Tick the checkbox when you have completed reading</small>
                            </v-stepper-step>

                            <v-stepper-content step="1">
                                <v-card color="#bdbdbd66" class="mb-5" height="300px" style="overflow-y: auto" @scroll="scrolledToBottom">
                                    <v-flex ma-3>
                                        <TeC></TeC>
                                    </v-flex>
                                </v-card>
                                <v-flex>
                                    <v-checkbox
                                            v-model="firstCondition"
                                            color="primary"
                                            :disabled="!reachedBottom"
                                    >
                                        <template v-slot:label>
                                            <div @click.stop="">
                                                I have read and understood the
                                                <strong>Terms & Conditions</strong>
                                            </div>
                                        </template>
                                    </v-checkbox>
                                </v-flex>
                                <v-btn color="primary" :disabled="!firstCondition" @click="goToStep2">Continue</v-btn>
                            </v-stepper-content>

                            <v-stepper-step :complete="stepper > 2" step="2">Check the conditions</v-stepper-step>

                            <v-stepper-content step="2">
                                <v-layout row wrap>
                                    <v-flex xs1>
                                        <v-checkbox
                                                v-model="secondCondition"
                                                color="primary"
                                        >
                                            <!--<template v-slot:label>
                                                <div>
                                                    In accordance with articles 1341 and 1342 of the Italian civil code, the Entrant declares to have read, understood and expressly accepts the following clauses:
                                                    <ol>
                                                        <li value="3">Entrant(s) obligations</li>
                                                        <li value="4">Limitation of liability</li>
                                                        <li value="5">Warranties and Indemnity</li>
                                                        <li value="6">Licence to use the contents created and submitted by the Entrant</li>
                                                        <li value="10">Choice of Law and forum selection</li>
                                                    </ol>
                                                </div>
                                            </template>-->
                                        </v-checkbox>
                                    </v-flex>
                                    <v-flex xs11>
                                        <div>
                                            In accordance with articles 1341 and 1342 of the Italian civil code, the Entrant declares to have read, understood and expressly accepts the following clauses:
                                            <ol>
                                                <li value="3">Entrant(s) obligations</li>
                                                <li value="4">Limitation of liability</li>
                                                <li value="5">Warranties and Indemnity</li>
                                                <li value="6">Licence to use the contents created and submitted by the Entrant</li>
                                                <li value="10">Choice of Law and forum selection</li>
                                            </ol>
                                        </div>
                                    </v-flex>
                                </v-layout>

                                <v-flex class="py-3">
                                    <v-btn color="primary" :disabled="!secondCondition" @click="finishSteps">Continue</v-btn>
                                </v-flex>

                            </v-stepper-content>

                        </v-stepper>
                    </v-flex>


                </v-card-text>
                <v-card-actions>
                    <v-spacer/>
                    <v-btn
                            round
                            color="red"
                            flat
                            @click="dialogTEC=false"
                    >
                        Close
                    </v-btn>
                    <v-btn
                            :disabled="!firstCondition || !secondCondition || stepper < 3"
                            round
                            color="green"
                            flat
                            @click="acceptTEC()"
                    >
                        Accept
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>


    </v-container>

</template>

<script>
    import UrlsService from "@/helpers/UrlsService.js";
    import APILoaderDecoratorService from "@/helpers/APILoaderDecoratorService";
    import TimeService from "@/helpers/TimeService";
    import FileInputChallenge from "@/components/Inputs/FileInputChallenge";
    import RouterService from "@/helpers/RouterService";
    import AlertService from "@/helpers/AlertService";
    import VueRecaptcha from 'vue-recaptcha';
    import TeC from "@/components/TeC/TeC";



    export default {
        name: "ChallengeRegistration",
        components: {TeC, FileInputChallenge,VueRecaptcha},
        props: {
            _id: String,
        },

        data() {
            return {
                tokenStatus:false,
                tokenError: false,
                token: "",
                document: "",
                validCaptcha: false,
                captchaToken: "",
                dialogTEC: true,
                dialogTextTEC: false,
                firstCondition: false,
                secondCondition: false,
                TECAccepted: false,
                stepper: 1,
                reachedBottom: false
            };
        },
        mounted() {
            let recaptchaScript = document.createElement('script');
            recaptchaScript.setAttribute('src', 'https://www.google.com/recaptcha/api.js?onload=vueRecaptchaApiLoaded&render=explicit');
            recaptchaScript.async = true;
            recaptchaScript.defer = true;
            document.head.appendChild(recaptchaScript)
        },
        methods: {
            finishSteps(){
                if(this.secondCondition) this.stepper = 3;
            },
            goToStep2(){
                if(this.firstCondition) this.stepper = 2;
            },
            scrolledToBottom(event){
                var el = event.srcElement
                if(!this.reachedBottom){
                    if(el.scrollTop >= (el.scrollHeight - el.clientHeight)-100){
                        this.reachedBottom = true
                    }
                }
            },
            acceptTEC(){
                this.dialogTEC= false;
                this.TECAccepted = true;

            },
            register (token) {
                this.captchaToken = token;
                this.validCaptcha = true;
            },

            onCaptchaExpired () {
                this.$refs.recaptcha.reset()
                this.validCaptcha = false;
            },
            submitCaptcha(){
                this.registerToChallenge(this.captchaToken);
                this.validCaptcha = false;
                this.$refs.recaptcha.reset()
            },
            navigate(path) {
                RouterService.goTo(path);
            },
            getFile(data){
                this.document = data
            },
            registerToChallenge(token){
                if(this.token === ""){
                    let alertOptions = {
                        type: "error",
                        message: "You have to insert a token!",
                    };
                    AlertService.createAlert(alertOptions);
                }
                else if(this.document === ""){
                    let alertOptions = {
                        type: "error",
                        message: "You have to upload a document!",
                    };
                    AlertService.createAlert(alertOptions);
                }
                else{
                    let requestUrl = {
                        url: UrlsService.registerToChallengePublic,
                        timeout: TimeService.secondsToMillis(0),
                    };
                    let requestData = {
                        idChallenge: this._id,
                        token: this.token,
                        file: this.document,
                        captchaResponse: token
                    };
                    let requestObject = {
                        type: "public",
                        urlsInfo: requestUrl,
                        data: {
                            data: requestData,
                        },
                    };
                    let messages = {
                        title: "Partecipate to challenge",
                        loading: "Waiting for registration...",
                        error: "Cannot register to challenge...",
                    };
                    let options = {
                        loadingType: "fullscreen",
                        timeout: TimeService.secondsToMillis(0),
                    };
                    APILoaderDecoratorService.setLoader(requestObject, messages, options)
                        .then(responseSuccess => {
                            let responseChallenge = responseSuccess;
                            if(responseChallenge === null){
                                this.tokenStatus = true;
                                this.tokenError = false;
                            }
                            else if(responseChallenge !== null && responseChallenge.response.status === 404){
                                this.tokenStatus = true;
                                this.tokenError = true;
                            }
                        });
                }


            }

        },
    };
</script>

<style lang="scss">

</style>
